var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('TheButton',{staticClass:"button",on:{"click":_vm.setRandomCause}}),_c('router-link',{attrs:{"to":_vm.currentLink}},[_c('CasusBibendi',{staticClass:"casus",attrs:{"casus":_vm.current}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }